document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.hv2-faqs .hv2-faqs__accordion-item');
    const accordionButton = document.querySelector('.hv2-faqs .hv2-faqs__accordion-button');

    if (accordionItems.length > 0 && accordionButton) {

        const accordion = document.querySelector('.hv2-faqs .hv2-faqs__accordion');
        const accordionCount = accordion.getAttribute('accordion-count');
        const maxItemsToShow = accordionCount;

        if (accordionItems.length > maxItemsToShow) {
            for (var i = maxItemsToShow; i < accordionItems.length; i++) {
                accordionItems[i].classList.add('hide');
            }
            accordionButton.style.display = 'block';
        }
        accordionButton.addEventListener('click', function (e) {
            e.preventDefault();
            for (var i = maxItemsToShow; i < accordionItems.length; i++) {
                accordionItems[i].classList.remove('hide');
            }
            accordionButton.style.display = 'none';
        });
    }

    if (accordionItems.length > 0) {

        const accordionHeadings = document.querySelectorAll('.hv2-faqs .hv2-faqs__accordion-heading');
        const accordionItems = document.querySelectorAll('.hv2-faqs__accordion-item');

        accordionHeadings.forEach(function (heading) {
            heading.addEventListener('click', function () {
                const accordionItem = this.closest('.hv2-faqs__accordion-item');

                accordionItems.forEach(function (item) {
                    let accordionContent = item.querySelector('.hv2-faqs__accordion-content');
                    if (item !== accordionItem && item.classList.contains('active')) {
                        item.classList.remove('active');
                        accordionContent.style.maxHeight = null;
                    }
                });

                accordionItem.classList.toggle('active');

                let accordionContent = accordionItem.querySelector('.hv2-faqs__accordion-content');
                if (accordionContent.style.maxHeight) {
                    accordionContent.style.maxHeight = null;
                } else {
                    accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
                }
            });
        });

    }

});